import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Terms & Conditions</h1>
      <p className="text-sm text-gray-500 mb-6">Last updated on: September 20, 2025</p>

      <p className="mb-6">
        Welcome to the website of <strong>AALADIPATTIYAN PRIVATE LIMITED</strong>. By accessing or
        using our website, you agree to comply with and be bound by the following Terms &
        Conditions, which together with our Privacy Policy govern our relationship with you in
        relation to this website.
      </p>

      <p className="mb-6">
        The term <strong>“AALADIPATTIYAN PRIVATE LIMITED”</strong> or “we/us/our” refers to the
        owner of the website whose registered office is:
      </p>

      <p className="mb-6">
        <strong>
          7/315–7/319, SDM to Anaikulam Road, Pandiyapuram, Tenkasi, Tamil Nadu, India – 627857.
        </strong>
      </p>

      <p className="mb-6">The term “you” refers to the user or viewer of our website.</p>

      <h2 className="text-xl font-semibold mt-8 mb-4">Terms of Use</h2>

      <h3 className="text-lg font-semibold mt-6 mb-2">1. General Information</h3>
      <ul className="list-disc list-inside space-y-2 pl-6 mb-6">
        <li>The content of this website is for your general information and use only.</li>
        <li>It is subject to change without notice.</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-2">2. Accuracy & Liability</h3>
      <ul className="list-disc list-inside space-y-2 pl-6 mb-6">
        <li>
          Neither we nor any third parties provide any warranty or guarantee as to the accuracy,
          timeliness, performance, completeness, or suitability of the information and materials
          found on this website.
        </li>
        <li>
          You acknowledge that such information may contain inaccuracies or errors, and we expressly
          exclude liability for any such issues to the fullest extent permitted by law.
        </li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-2">3. User Responsibility</h3>
      <ul className="list-disc list-inside space-y-2 pl-6 mb-6">
        <li>
          Your use of any information or materials on this website is entirely at your own risk, for
          which we shall not be liable.
        </li>
        <li>
          It shall be your responsibility to ensure that any products, services, or information
          available through this website meet your specific requirements.
        </li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-2">4. Intellectual Property</h3>
      <ul className="list-disc list-inside space-y-2 pl-6 mb-6">
        <li>
          This website contains material which is owned by or licensed to us. This includes, but is
          not limited to, the design, layout, look, appearance, and graphics.
        </li>
        <li>
          Reproduction is prohibited except in accordance with the copyright notice, which forms part
          of these Terms & Conditions.
        </li>
        <li>
          All trademarks reproduced on this website which are not the property of, or licensed to,
          <strong> AALADIPATTIYAN PRIVATE LIMITED</strong> are acknowledged accordingly.
        </li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-2">5. Prohibited Use</h3>
      <p className="mb-6 pl-6">
        Unauthorized use of this website may give rise to a claim for damages and/or constitute a
        criminal offense.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-2">6. Third-Party Links</h3>
      <ul className="list-disc list-inside space-y-2 pl-6 mb-6">
        <li>
          From time to time, this website may include links to other websites. These links are
          provided for your convenience to supply additional information.
        </li>
        <li>We are not responsible for the content of linked websites.</li>
      </ul>

      <h3 className="text-lg font-semibold mt-6 mb-2">7. External Linking</h3>
      <p className="mb-6 pl-6">
        You may not create a link to this website from another website or document without prior
        written consent from <strong>AALADIPATTIYAN PRIVATE LIMITED</strong>.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-2">8. Governing Law</h3>
      <p className="mb-6 pl-6">
        Your use of this website and any dispute arising out of such use shall be governed by the
        laws of India and subject to the jurisdiction of the appropriate regulatory authority.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-2">9. Transactions & Liability</h3>
      <p className="mb-6 pl-6">
        As a merchant, we shall not be held liable for any loss or damage arising directly or
        indirectly out of the decline of authorization for any transaction, due to the cardholder
        having exceeded the preset limit agreed with our acquiring bank.
      </p>

      <p className="mt-8 text-sm text-gray-600 italic">
        Disclaimer: This policy is drafted and managed solely by{" "}
        <strong>AALADIPATTIYAN PRIVATE LIMITED</strong>. Razorpay shall not be responsible for the
        content of this document or for any claims or liabilities that may arise due to the
        merchant’s non-adherence to it.
      </p>
    </div>
  );
};

export default TermsAndConditions;
